import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid,
} from "recharts";
import {
    FaBuilding, FaMapMarkerAlt, FaSchool, FaUsers, FaBox, FaUserCog, FaUserGraduate, FaClipboardList, FaWarehouse,
} from "react-icons/fa";
import { motion } from "framer-motion";

// --- Icon Map for backend values ---
const iconMap = {
    FaBuilding: FaBuilding,
    FaMapMarkerAlt: FaMapMarkerAlt,
    FaSchool: FaSchool,
    FaUsers: FaUsers,
    FaBox: FaBox,
    FaUserCog: FaUserCog,
    FaUserGraduate: FaUserGraduate,
    FaClipboardList: FaClipboardList,
    FaWarehouse: FaWarehouse,
};

const baseUrl = process.env.REACT_APP_BASE_URL;
console.log("basUrl", baseUrl);
// --- Card ---
const StatCard = ({ title, value, icon, color }) => (
    <motion.div
        whileHover={{ scale: 1.05 }}
        style={{
            background: "#fff",
            padding: "20px",
            boxShadow: "0 2px 8px 0 rgba(0,0,0,0.07)",
            borderRadius: "16px",
            border: "1px solid #e5e7eb",
            transition: "box-shadow 0.2s",
            marginBottom: "16px",
            minWidth: 0,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
        }}
    >
        <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    marginRight: 12,
                    backgroundColor: `${color || "#000"}`,
                    background: `${color || "#000"}20 !important`
                }}
            >
                <span
                    style={{
                        fontSize: 24,
                        color: `${color || "#000"} !important`
                    }}
                >
                    {icon && React.createElement(icon)}
                </span>
            </div>
            <h3 style={{
                fontSize: 16,
                fontWeight: 600,
                color: "#374151",
                margin: 0
            }}>{title}</h3>
        </div>

        <p style={{
            fontSize: 28,
            fontWeight: 700,
            color: "#111827",
            margin: 0
        }}>{value ?? 0}</p>
    </motion.div>
);

// --- Dashboard ---
function DashboardPHP() {
    const [token, setToken] = useState(() => sessionStorage.getItem("token"));
    const [currentRowData, setCurrentRowData] = useState([]);
    const [dashboardData, setDashboardData] = useState([]);

    // Dummy arrays for color/icon mapping
    const currentRowData1 = [
        { name: "Current User", color: "#4B0082", icon: FaUserCog },
        { name: "Current Sale", color: "#FF4500", icon: FaUsers },
        { name: "Current Purchase", color: "#2E8B57", icon: FaClipboardList },
        { name: "Current Stock", color: "#1E90FF", icon: FaWarehouse },
    ];

    const dashboardData1 = [
        { name: "Firm Entry", color: "#0088FE", icon: FaBuilding },
        { name: "Zone Entry", color: "#00C49F", icon: FaMapMarkerAlt },
        { name: "School Entry", color: "#FFBB28", icon: FaSchool },
        { name: "Sale & Purchase", color: "#FF8042", icon: FaUsers },
        { name: "Item Master", color: "#A020F0", icon: FaBox },
        { name: "User Master", color: "#ee0882", icon: FaUserCog },
        { name: "Student Entry", color: "#32CD32", icon: FaUserGraduate },
        { name: "Total Entry", color: "#8B4513", icon: FaClipboardList },
        { name: "Total Stock", color: "#4682B4", icon: FaWarehouse },
    ];

    const staticDashboardData = [
        { name: "Firm Entry", value: 3 },
        { name: "Zone Entry", value: 7 },
        { name: "School Entry", value: 6 },
        { name: "Student Entry", value: 12 },
        { name: "Item Master", value: 4 },
        { name: "User Master", value: 20 },
        { name: "Sale & Purchase", value: 1 },
        { name: "Total Entry", value: 52 },
        { name: "Total Stock", value: 180 },
    ];

    // Helper to map backend data to dummy color/icon
    const mapWithColors = (apiData, dummyData) => {
        return dummyData.map(dummy => {
            const found = apiData.find(item => item.name?.toLowerCase() === dummy.name.toLowerCase());
            let iconComp = dummy.icon;
            if (found && found.icon && iconMap[found.icon]) {
                iconComp = iconMap[found.icon];
            }
            return {
                ...dummy,
                ...(found || {}),
                value: found ? found.value : 0,
                icon: iconComp,
            };
        });
    };

    // Update display arrays when API data changes
    useEffect(() => {
        const mappedCurrentData = mapWithColors(currentRowData, currentRowData1);
        setCurrentRowDisplay(mappedCurrentData);
    }, [currentRowData]);

    useEffect(() => {
        const mappedDashboardData = mapWithColors(dashboardData, dashboardData1);
        setDashboardDisplay(mappedDashboardData);
    }, [dashboardData]);

    const [currentRowDisplay, setCurrentRowDisplay] = useState(currentRowData1.map(d => ({ ...d, value: 0 })));
    const [dashboardDisplay, setDashboardDisplay] = useState(dashboardData1.map(d => ({ ...d, value: 0 })));

    // Fetch Data
    // useEffect(() => {
    //     console.log("token=>",token);
    //     if (!token) {
    //         console.log("No token found, skipping API calls.");
    //         // Set static data immediately if there is no token
    //         setDashboardData(staticDashboardData);
    //         return;
    //     }

    //     // Fetch current data

    //     axios.get(`${baseUrl}/currentDashbordRecord`, {
    //         headers: { Authorization: `Bearer ${token}` }
    //     })

    //         .then(res => setCurrentRowData(res.data || []))
    //         .catch(error => {
    //             console.error("Error fetching current data:", error);
    //             setCurrentRowData([]);
    //         });

    //     // Fetch dashboard data
    //     axios.get(`${baseUrl}/dashboard`, {
    //         headers: { Authorization: `Bearer ${token}` }
    //     })
    //         .then(res => {
    //             setDashboardData(res.data);
    //         })
    //         .catch(error => {
    //             console.error("Error fetching dashboard data:", error);
    //             setDashboardData([]);
    //         })
    //         .finally(() => {
    //             // Set static data if no data was returned from the API
    //             setDashboardData(currentData => {
    //                 return currentData.length > 0 ? currentData : staticDashboardData;
    //             });
    //         });
    // }, [token, baseUrl, staticDashboardData]);
     const staticCurrentData = currentRowData1.map(d => ({ ...d, value: 0 }));
const fetchDashboard = async () => {
  try {
    const res = await axios.get(`${baseUrl}?apicall=dashboard`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const apiData = Array.isArray(res.data.data) ? res.data.data : [];

    // Map backend values to local icons/colors
    const formatted = dashboardData1.map(item => ({
      ...item,
      value: apiData.find(d => d.name === item.name)?.value ?? 0,
    }));

    console.log("Mapped Dashboard Data:", formatted);
    setDashboardData(formatted);
    setDashboardDisplay(formatted);

  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    // fallback to static if error
    setDashboardData(staticDashboardData);
    setDashboardDisplay(dashboardData1.map(d => ({
      ...d,
      value: staticDashboardData.find(s => s.name === d.name)?.value ?? 0,
    })));
  }
};
  const fetchCurrentDashboard = async () => {
            try {
                const res = await axios.get(`${baseUrl}?apicall=currentDashbordRecord`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                //     //  console.log("Full Axios response:", res);
                // console.log("res.data type:", typeof res.data);
                // console.log("res.data:", res.data);
                //       console.log("Current Dashboard Response:", res.data);

                const apiData = Array.isArray(res.data.data) ? res.data.data : [];
                console.log("apidata=>", apiData);
                // Map API values to icons/colors

                const formatted = currentRowData1.map(item => ({
                    ...item,
                    value: apiData.find(d => d.name === item.name)?.value ?? 0,
                }));

                console.log("Mapped Current Dashboard:", formatted);
                setCurrentRowDisplay(formatted);

            } catch (error) {
                console.error("Error fetching current dashboard:", error);
                setCurrentRowDisplay(staticCurrentData);
            }
        };

    useEffect(() => {
        // Dummy array with icons and colors
        const currentRowData1 = [
            { name: "Current User", color: "#4B0082", icon: FaUserCog },
            { name: "Current Sale", color: "#FF4500", icon: FaUsers },
            { name: "Current Purchase", color: "#2E8B57", icon: FaClipboardList },
            { name: "Current Stock", color: "#1E90FF", icon: FaWarehouse },
        ];

        // Static fallback
       
        if (!token) {
    console.log("No token found, using static data.");
    setDashboardDisplay(dashboardData1.map(d => ({
      ...d,
      value: staticDashboardData.find(s => s.name === d.name)?.value ?? 0,
    })));
    return;
  }
      
fetchDashboard();
  fetchCurrentDashboard();

       
    }, [token, baseUrl]);


    return (
        <div style={{ marginTop: "50px", background: "#f3f4f6", minHeight: "100vh" }}>
            <div style={{ maxWidth: 1200, margin: "0 auto", padding: 24 }}>
                {/* Current Row */}
                <section style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                    gap: 16,
                    marginBottom: 32
                }}>
                    {currentRowDisplay.map((item, i) => (
                        <StatCard
                            key={i}
                            title={item.name}
                            value={item.value}
                            icon={item.icon}
                            color={item.color}
                        />
                    ))}
                </section>

                {/* Main Content */}
                <main style={{ display: "flex", flexDirection: "column", gap: 32 }}>
                    <div style={{ display: "flex", flexDirection: "row", gap: 32, flexWrap: "wrap" }}>
                        {/* Left Cards */}
                        <section style={{
                            flex: "3 1 0%",
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                            gap: 16
                        }}>
                            {dashboardDisplay.map((item, i) => (
                                <StatCard
                                    key={i}
                                    title={item.name}
                                    value={item.value}
                                    icon={item.icon}
                                    color={item.color}
                                />
                            ))}
                        </section>

                        {/* Right Charts */}
                        <section style={{
                            flex: "2 1 0%",
                            display: "flex",
                            flexDirection: "column",
                            gap: 16,
                            minWidth: 320
                        }}>
                            {/* Pie */}
                            <div style={{
                                background: "#fff",
                                padding: 24,
                                boxShadow: "0 2px 8px 0 rgba(0,0,0,0.07)",
                                borderRadius: 16
                            }}>
                                <h2 style={{ fontSize: 18, fontWeight: 600, color: "#374151", marginBottom: 16 }}>
                                    Entries Overview
                                </h2>
                                <div style={{ width: "100%", height: 350 }}>
                                    <ResponsiveContainer>
                                        <PieChart>
                                            <Pie
                                                data={dashboardDisplay.length > 0 ? dashboardDisplay : [{ name: "No Data", value: 0, color: "#ccc" }]}
                                                cx="50%"
                                                cy="50%"
                                                innerRadius={70}
                                                outerRadius={120}
                                                dataKey="value"
                                                nameKey="name"
                                            >
                                                {(dashboardDisplay.length > 0 ? dashboardDisplay : [{ color: "#ccc" }]).map((entry, i) => (
                                                    <Cell key={i} fill={entry.color || "#ccc"} />
                                                ))}
                                            </Pie>
                                            <Tooltip />
                                            <Legend />
                                        </PieChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>

                            {/* Bar */}
                            <div style={{
                                background: "#fff",
                                padding: 24,
                                boxShadow: "0 2px 8px 0 rgba(0,0,0,0.07)",
                                borderRadius: 16
                            }}>
                                <h2 style={{ fontSize: 18, fontWeight: 600, color: "#374151", marginBottom: 16 }}>
                                    Stock vs Entries
                                </h2>
                                <div style={{ width: "100%", height: 300 }}>
                                    <ResponsiveContainer>
                                        <BarChart data={dashboardDisplay.length > 0 ? dashboardDisplay : [{ name: "N/A", value: 0 }]}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="name" />
                                            <YAxis />
                                            <Tooltip />
                                            <Bar dataKey="value" fill="#4B0082" radius={[4, 4, 0, 0]} />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </section>
                    </div>
                </main>
            </div>
        </div>
    );
}

export default DashboardPHP;